import httpClient from "./httpClient";

const END_POINT = "/api/cursos";

const getCursosByAnioDesc = async () => {
  return await httpClient.get(END_POINT, {
    params: {
      "order[anio]": "desc",
      pagination: "false",
    },
  });
};

const sortear = async (idLocalizacion, numero, fase) => {
  return await httpClient.post(`${END_POINT}/realizar-sorteo`, {
    idLocalizacion: idLocalizacion,
    numero: parseInt(numero),
    fase: parseInt(fase),
  });
};

const enviarEmails = async (idLocalizacion, fase) => {
  return await httpClient.post(`${END_POINT}/enviar-emails-sorteo`, {
    idLocalizacion: idLocalizacion,
    fase: parseInt(fase),
  });
};

export { getCursosByAnioDesc, sortear, enviarEmails };
